import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M5 9a7 7 0 1114 0c0 5.3-7 13-7 13S5 14.2 5 9zm7-5a5 5 0 00-5 5c0 2.8 3 7.2 5 9.9 2.1-2.7 5-7 5-9.9a5 5 0 00-5-5zm2.5 5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" }));
export {
  a as ReactComponent
};
